































import { Component, Prop, Vue, Model, Watch } from "vue-property-decorator";
import IPlaylistEditor from "./pieces/i-playlist-editor.vue";
import IInterestEditor from "./pieces/i-interest-editor.vue";
import IActivityEditor from "./pieces/i-activity-editor.vue";
import IWorkEditor from "./pieces/i-work-editor.vue";
import IMomentEditor from "./pieces/i-moment-editor.vue";
import IImageEditor from "./pieces/i-image-editor.vue";
import IInput from "@/components/i-input.vue";

@Component({
  components: {
    IInput,
    IPlaylistEditor,
    IInterestEditor,
    IActivityEditor,
    IWorkEditor,
    IMomentEditor,
    IImageEditor
  }
})
export default class IInputBox extends Vue {
  @Model("model") value!: any;
  @Watch("value")
  watchValue(val: any) {
    this.onValueChange(val);
  }

  @Prop() type!: string;
  @Prop() cloud!: any;

  private struct: any = {};

  mounted() {
    this.struct = this.getStructure(this.type);
    console.log(this.struct);
  }

  private onValueChange(value: any) {
    this.$emit("model", value);
    this.$emit("on-change", value);
  }

  private addItem() {
    this.value.push(this.$utils.clone(this.struct, true));
    this.onValueChange(this.value);
  }

  private removeItem(index: number) {
    this.value.splice(index, 1);
    this.onValueChange(this.value);
  }

  private upItem(index: number) {
    if (index >= 1)
      this.value[index] = this.value.splice(index - 1, 1, this.value[index])[0];
  }

  private downItem(index: number) {
    if (index < this.value.length - 1)
      this.value[index] = this.value.splice(index + 1, 1, this.value[index])[0];
  }

  private getStructure(type: string) {
    switch (type) {
      case "work":
        return {
          span: "",
          ratio: "",
          scaler: {
            data: {
              base: "",
              content: "",
              href: "",
              image: "",
              title: ""
            },
            type: ""
          }
        };
      default:
        return {};
    }
  }
}
